import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 24,
  medium: 16,
  small: 14,
  xSmall: 9
};
const EditIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "small":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement("path", { d: "M5.83239 12.9088L5.20297 13.5382L6.46181 14.797L7.09124 14.1676L5.83239 12.9088Z", fill: "currentColor" }),
          /* @__PURE__ */ React.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.77653 17H3V13.2235L12.4413 3.78215C13.4842 2.73928 15.175 2.73929 16.2179 3.78215C17.2607 4.82501 17.2607 6.51582 16.2179 7.55868L6.77653 17ZM3.89056 16.1094L6.40951 16.1094L15.5884 6.92925C16.2521 6.26561 16.2822 5.20839 15.6789 4.50897L15.5884 4.41156C14.9248 3.74793 13.8676 3.71776 13.1682 4.32107L13.0708 4.41156L3.89119 13.5923L3.89056 16.1094Z",
              fill: "currentColor"
            }
          )
        );
      case "large":
      case "medium":
      case "xSmall":
      default:
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement("path", { d: "M10.3033 18.3743L9.59621 19.0815L11.0104 20.4957L11.7175 19.7886L10.3033 18.3743Z", fill: "currentColor" }),
          /* @__PURE__ */ React.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.364 22.9705H7.12134V18.7279L17.7279 8.12129C18.8995 6.94972 20.799 6.94972 21.9706 8.12129C23.1422 9.29287 23.1422 11.1924 21.9706 12.3639L11.364 22.9705ZM8.12182 21.97L10.9517 21.97L21.2635 11.6568C22.009 10.9113 22.0429 9.72357 21.3651 8.93782L21.2635 8.8284C20.5179 8.08285 19.3302 8.04896 18.5445 8.72673L18.4351 8.8284L8.12252 19.1423L8.12182 21.97Z",
              fill: "currentColor"
            }
          )
        );
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, renderIcon());
};
EditIcon.iconName = "EditIcon";

export { EditIcon };
